export default function initCookieConsent() {
    function pushDatalayer(event, eventLabel, eventStatus = '') {
        if (window.dataLayer) {
            dataLayer.push({
                event,
                eventLabel,
                eventStatus,
            });
        }
    }

    function checkboxLoop(settingsForm) {
        const checkBoxes = settingsForm.querySelectorAll('input[type="checkbox"]');
        checkBoxes.forEach((checkbox) => {
            const cookieType = checkbox.getAttribute('id').replace('cookie-consent-', '');
            if (checkbox.hasAttribute('checked')) {
                pushDatalayer('cookie-notice', 'accepted', cookieType);
            } else {
                pushDatalayer('cookie-notice', 'declined', cookieType);
            }
        });
    }

    function showCookieNotice() {
        document.querySelector('[data-cmeleon-cookie-notice]').classList.add('active');
        pushDatalayer('cookie-notice', 'shown');
    }

    function hideCookieNotice() {
        document.querySelector('[data-cmeleon-cookie-notice]').classList.remove('active');
    }

    function showCookieSettings() {
        if (document.querySelector('[data-cmeleon-cookie-notice]')) {
            hideCookieNotice();
        }
        document.querySelector('[data-cmeleon-cookie-settings]').classList.add('active');
    }

    function acceptAllCookies() {
        document.querySelectorAll('input[type="checkbox"]').forEach((c) => {
            c.checked = true;
        });

        document.querySelector('[data-cmeleon-cookie-settings]').querySelector('form').submit();
        const settingsForm = document.querySelector('[data-cmeleon-cookie-settings] form');

        checkboxLoop(settingsForm);
        pushDatalayer('cookie-notice', 'clicked', 'accept-all');
    }

    window.onload = () => {
        if (document.querySelector('[data-cmeleon-cookie-notice]') !== null) {
            document.querySelectorAll('[data-cmeleon-cookie-trigger]').forEach((trigger) => {
                switch (trigger.getAttribute('data-cmeleon-cookie-trigger')) {
                case 'show-settings':
                    return trigger.addEventListener('click', () => {
                        showCookieSettings();
                    });
                default:
                    return trigger.addEventListener('click', () => acceptAllCookies());
                }
            });

            setTimeout(() => showCookieNotice(), 1000);
        }

        if (document.querySelector('[data-cmeleon-cookie-settings]') !== null) {
            const settingsForm = document.querySelector('[data-cmeleon-cookie-settings] form');
            settingsForm.addEventListener('submit', () => {
                checkboxLoop(settingsForm);
                pushDatalayer('cookie-notice', 'clicked', 'accept-specific');
            });
        }

        if (document.querySelector('[data-cmeleon-cookie-update-settings]')) {
            document.querySelector('[data-cmeleon-cookie-update-settings]').addEventListener('click', function(e) {
                e.preventDefault();
                showCookieSettings();
            });
        }
    };
}
